import { html, css, TemplateResult, CSSResultGroup } from 'lit'
import { customElement, property } from 'lit/decorators.js'
import { BaseComponent } from './base-component.js'

@customElement('il-list-item')
export default class ListItemComponent extends BaseComponent {
  @property({ type: String }) header?: string = ''
  @property({ type: String, attribute: 'sub-header' }) subHeader?: string = ''
  @property({ type: Boolean }) bold = false

  headers(): TemplateResult {
    if (this.header || this.subHeader) {
      return html` <div class="il-list-item__headers">${this.headerTemplate()} ${this.subHeaderTemplate()}</div> `
    }

    return html``
  }

  headerTemplate(): TemplateResult {
    if (this.header) {
      return html` <h1 class="il-list-item__header il-font-component-xbold-16">${this.header}</h1> `
    }

    return html``
  }

  subHeaderTemplate(): TemplateResult {
    if (this.subHeader) {
      return html` <h2 class="il-list-item__sub-header il-font-component-bold-14">${this.subHeader}</h2> `
    }

    return html``
  }

  override render(): TemplateResult {
    return html`
      <div data-testid="il-list-item" class="${this.baseCSSClass} il-list-item">
        <div class="il-list-item__left">
          ${this.headers()}
          <slot></slot>
        </div>

        <div class="il-list-item__right">
          <slot name="right"></slot>
        </div>
      </div>
    `
  }

  static override styles: CSSResultGroup = [
    BaseComponent.styles,
    css`
      :host {
        width: 100%;
      }

      .il-list-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 8px;
        width: 100%;
      }

      .il-list-item__left {
        display: flex;
        flex-direction: column;
        gap: 12px;
      }

      .il-list-item__left ::slotted(*) {
        font-size: var(--il-font-size-14);
        font-weight: var(--il-font-weight-normal);
        line-height: var(--il-font-line-height-140);
        letter-spacing: var(--il-font-letter-spacing-2);
        color: var(--il-color-neutrals-300);
      }

      .il-list-item__headers {
        display: flex;
        flex-direction: column;
        gap: 4px;
      }

      .il-list-item__header {
        color: var(--il-color-neutrals-300);
        margin: 0;
      }

      .il-list-item__sub-header {
        color: var(--il-color-neutrals-300);
        margin: 0;
      }
    `,
  ]
}

declare global {
  interface HTMLElementTagNameMap {
    'il-list-item': ListItemComponent
  }
}
